<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      :title="'已缴费用，项目：'+house_name"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="selects_s">查询</el-button>
        <!-- <el-button>批量红冲</el-button> -->
        <el-button @click="log_s">日志</el-button>
        <el-button @click="pay">修改支付方式</el-button>
        <el-button @click="del">清空结算方式</el-button>
        <el-button  v-if="ERP.isPermission(4003007009) && type == 1" @click="writeOff">冲销</el-button>
        <!-- <el-button>批量冲销</el-button> -->
        <el-button  v-if="ERP.isPermission(4003007007) && type == 1" @click="redFlush">红冲</el-button>
        <el-button @click="order_excel">导出缴款记录</el-button>
        <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
              <el-descriptions-item  label="客户名称">
                <el-select v-model="select.name"  size="mini" placeholder="客户名称" filterable remote clearable reserve-keyword style="width: 100%;">
                    <el-option v-for="item in customer" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item label="房产信息">
                <el-select v-model="select.house" @change="houses" size="mini" placeholder="可搜索房产,搜索房产自动切换项目" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                    <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item label="查询方式">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="date.type">
                      <Radio label="模糊查询"></Radio>
                      <Radio label="精确查询"></Radio>
                  </RadioGroup>
                </Space>
              </el-descriptions-item>
              <el-descriptions-item  label="计费周期">
                <el-date-picker v-model="date.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="date.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item  label="缴费日期">
                <el-date-picker v-model="date.date_s" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="date.date_e" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item label="收费项目">
                <el-select v-model="select.chargeitem_id" size="mini" multiple filterable collapse-tags placeholder="收费项目" style="width: 90.5%;">
                    <el-option v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                </el-select>
                <span style="cursor: pointer;margin-left: 3px;" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
              </el-descriptions-item>
              <el-descriptions-item label="结算方式">
                <RadioGroup v-model="select.pay">
                  <div style="display: flex;flex-wrap: wrap;">
                    <div v-for="it in dataPay" :key="it.id">
                        <Radio :label="it.number">{{it.name}}</Radio>
                    </div>
                  </div>
                </RadioGroup>
              </el-descriptions-item>
              <el-descriptions-item label="票据查询">
                <el-input size="mini" v-model="date.xsc_bill_no" clearable placeholder="票据号码"></el-input>
              </el-descriptions-item>
            </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总金费：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <span v-if="ERP.isPermission(4003007009) || ERP.isPermission(4003007007)" style="margin-left: 15px;">需要部分冲销或者红冲，修改冲销/红冲金额</span>
          <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="47vh"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="customer" label="姓名" width="100"></el-table-column>
            <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="chargeitem_name" label="收费项目" width="130"></el-table-column>
            <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
            <el-table-column prop="xsc_Amount" label="数量" width="80"></el-table-column>
            <el-table-column label="计费周期" width="180">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="charge_paid" label="收款金额" width="80"></el-table-column>
            <el-table-column prop="dis_count" label="减免金额" width="80"></el-table-column>
            <el-table-column prop="delay_dis_count" label="减免违约金" width="100"></el-table-column>
            <el-table-column v-if="ERP.isPermission(4003007009) || ERP.isPermission(4003007007)" label="冲销/红冲金额" width="120">
              <template slot-scope="scope">
                <!-- {{scope.row.charge_paid}} -->
                <el-input size="mini" v-model="tableData[scope.$index].charge_paid_money" clearable placeholder="收款金额"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="state_name" label="状态" width="60"></el-table-column>
            <el-table-column prop="payment" label="支付方式" width="109"></el-table-column>
            <el-table-column prop="operator_date" label="缴款时间" width="150"></el-table-column>
            <el-table-column prop="xsc_bill_no" label="票据号码" width="150"></el-table-column>
            <el-table-column prop="account_book" label="所属日期" width="100"></el-table-column>
            <el-table-column prop="month_end_date" label="月结日期" width="100"></el-table-column>
            <el-table-column prop="remark" label="备注" width="200"></el-table-column>
            <el-table-column prop="log_name" label="操作人" width="100"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pages">
        <!-- <Page :total="total" :page-size="page" @on-change="selects" show-total /> -->
        <el-pagination @size-change="selects"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[20,50,100,200,300,400,500]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      data () {
        return {
          total:0,
          page:1,
          type:1,
          pageSize:20,
          loading_dade:1,
          dialogVisible:false,
          tableData: [],
          order: [],
          money_val:0,
          money:0,
          date:{
            date_s:'',
            date_e:'',
            startDate:'',
            endDate:'',
            type:'模糊查询',
            xsc_bill_no:'',
          },
          select:{
            pay:'',
            house:'',
            name:'',
            date:'',
            chargeitem_id:[],
          },
          customer:[],
          dataPay:[],
          xsc_bill_no:'',
          house:[],
          chargeitem:[],
          loading:false,
          pid:'',
          house_name:'',
        }
      },
      mounted(){
        //加载收费大类（费项）
        this.$myhttp
          .get("admin/common/getChargeitem", {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.chargeitem = backdata.data.data;
          });
      },
      //事件
      methods: {
        //返回数据
        getInvo(data,house,dataPay,customer,pid){
          this.pid = pid;
          this.select = data;
          if(this.date.date_s == ''){
            this.date.date_s  = data.date;
            this.date.date_e = data.date;
          }
          this.select.pay = '';
          this.dataPay = dataPay;
          this.house = house;
          this.customer = customer;
          this.dialogVisible = true;
          this.selects_s();
          this.housePid();
        },
        del(){
          this.select.pay = '';
        },
        //全选
        complete() {
          let data = this.chargeitem;
          let id = data
            .map((ret) => {
              return ret.id;
            })
            .join(",");
          let idarray = "[" + id + "]";
          this.select.chargeitem_id = JSON.parse(idarray);
        },
        //取消
        cancel() {
          this.select.chargeitem_id = [];
        },
        //修改支付方式
        pay(){
          if(this.select.pay == ''){
            this.$Message.error('请选择结算方式!');
            return false;
          }
          this.$confirm('确定修改支付方式吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let data = {'order':this.order,'pay':this.select}
            this.$myhttp.post('admin/OrderList/updatePay',data,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.loading = false;
                if(backdata.data.code == 201){
                  this.$confirm(''+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {})
                  // this.$Message.error(backdata.data.message);
                }else{
                  // this.$Message.success(backdata.data.message);
                  this.selects(this.pageSize);
                  this.$confirm(''+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {})
                }
            },err=>{
              this.loading = false;
              this.$Message.error('请求异常!');
            });
          })
        },
        // 冲销
        writeOff(){
          this.$confirm('确定冲销吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            this.$myhttp.post('admin/OrderList/writeOff',this.order,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.loading = false;
                if(backdata.data.code == 201){
                  this.$confirm(''+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {})
                  // this.$Message.error(backdata.data.message);
                }else{
                  // this.$Message.success(backdata.data.message);
                  this.selects_s();
                  this.$confirm(''+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {})
                }
            },err=>{
              this.loading = false;
              this.$Message.error('请求异常!');
            });
          })
        },
        //红冲
        redFlush(){
          this.$confirm('确定红冲吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            this.$myhttp.post('admin/OrderList/redFlush',this.order,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.loading = false;
                if(backdata.data.code == 201){
                  this.$confirm(''+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {})
                  // this.$Message.error(backdata.data.message);
                }else{
                  // this.$Message.success(backdata.data.message);
                  this.selects_s();
                  this.$confirm(''+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {})
                }
            },err=>{
              this.loading = false;
              this.$Message.error('请求异常!');
            });
          })
        },
        selects_s(){
          this.money = "加载中";
          this.total = 1;
          if(this.type != 1){
            this.page = 1;
          }
          this.type = 1;
          this.selects(this.pageSize);
          let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'type':1,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
          //分页
          this.$myhttp.post('admin/OrderList/paid_count',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.total = backdata.data.count;
          },err=>{
            this.$Message.error('请求异常!');
          });
          //金额
          this.$myhttp.post('admin/OrderList/paid_money',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.money = backdata.data.money;
          },err=>{
            this.$Message.error('请求异常!');
          });
        },
        // 查询
        selects(e){
          if(e){
            this.pageSize = e;//1页多少条
          }
          this.loading_dade = 2;
          let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'type':this.type,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
          this.$myhttp.post('admin/OrderList/paid',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.tableData = backdata.data.data;
              this.loading_dade = 1;
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
        //导出
        order_excel(){
          this.loading_dade = 2;
          let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'type':this.type,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
          this.$myhttp.post('admin/OrderList/paid_order_excel',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading_dade = 1;
              if(backdata.data.code==200){
                var url = this.$myhttp.defaults.baseURL+"/"+backdata.data.data;
                window.open(url, '_blank');
              }else{
                this.$Message.error(backdata.data.message);
              }
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
        handleCurrentChange(e){
          this.page = e;//第几页
          this.selects(this.pageSize);
        },
        log_s(){
          this.money = "加载中";
          this.total = 1;
          this.log(1);
          if(this.type != 2){
            this.page = 1;
          }
          this.type = 2;
          let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'type':2,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
          //分页
          this.$myhttp.post('admin/OrderList/paid_count',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.total = backdata.data.count;
          },err=>{
            this.$Message.error('请求异常!');
          });
          //金额
          this.$myhttp.post('admin/OrderList/paid_money',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.money = backdata.data.money;
          },err=>{
            this.$Message.error('请求异常!');
          });
        },
        //冲销日记
        log(e){
          this.loading_dade = 2;
          let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'type':2,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
          this.$myhttp.post('admin/OrderList/paid',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading_dade = 1;
              this.tableData = backdata.data.data;
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
        handleClose(done) {
          done();
        },
        handleSelectionChange(val) {
          this.order = val;
          let money = 0;
          this.order.map(req=>{
              money = Number(money) + Number(req.charge_paid);
          })
          this.money_val = money.toFixed(2);
        },
        //远程搜索
        remoteMethod(query){
          if (query !== '') {
            this.$myhttp.get('admin/common/house_name1?house_name='+encodeURIComponent(query)+'&pid='+this.pid,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.house = backdata.data.data;
            });
          }
        },
        //更换项目id
        houses(e){
          if(e){
            this.house.map(req=>{
              if(req.house == e){
                this.pid = req.erp_pindex_id;
              }
            })
          }
          this.housePid();
        },
        //查询当前项目
        housePid(){
          this.$myhttp.get('admin/common/house_pid?pid='+this.pid+"&house="+encodeURIComponent(this.select.house),{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data.code == 200){
                this.house_name = backdata.data.data.name;
                this.pid = backdata.data.data.id;
              }
          });
        }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/paids.vue